/*
  * list: Contains all the Invitations that have been sent out to
    join a Team
  ** A list has a 1-to-many to relationship with Account
  * current: Contains the information required to signup an invited
    member to join a Team
  ** An invitation has 1-to-1 to relationship with User
*/

export default {
  list: [],
  current: {
    id: null,
    inviter_id: null,
    account: {},
    role: null,
    invitee_email: null,
  },
};
